import React from 'react'
import { Button, Popup } from 'semantic-ui-react'
import useMedia from "use-media";

const onClick = () => {
  window.open(
    'https://www.amazon.co.jp/hz/wishlist/ls/5IDHADIY6LDQ?type=wishlist&filter=unpurchased&sort=priority&viewType=list',
    '_blank'
  )
}

const GiftButton = ({ className }) => {
  const isMobile = useMedia({ maxWidth: "830px" })

  if (isMobile) {
    return null
  }

  return (
    <Popup
      content='子どもが生まれました🎉'
      open
      position='left center'
      size='mini'
      trigger={
        <Button className={className} onClick={onClick} color={'orange'} icon='gift' content='寄付する' />
      }
    />
  )
}

export default GiftButton
